import { DigandoBreadcrumbItem } from "../components/breadcrumb/digando-breadcrumb";

export const breadcrumbSchema = (items: DigandoBreadcrumbItem[]) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, id) => {
      return {
        '@type': 'ListItem',
        position: id + 1,
        item: {
          '@id': item.href,
          name: item.name,
        },
      };
    }),
  };
}
